<script>
import Carousel from "@/components/carousel";

export default {
  name: "screen-table",
  components: {
    Carousel,
  },
  props: {
    data: Array,
    columns: Array,
    border: Boolean,
    background: Boolean,
    /**
     * 是否开启轮播
     */
    carousel: Boolean,
    /**
     * 轮播显示行数
     */
    rowNumber: {
      type: Number,
      default: 3,
    },
    size: {
      type: String,
      default: "medium",
    },
    scrollOffset: {
      type: Number,
      default: 72,
    },
  },
  data() {
    return {};
  },
  computed: {
    tableClass() {
      return ["screen-table", `screen-table-${this.size}`].join(" ");
    },
  },
  render() {
    return (
      <div class={this.tableClass}>
        {this.renderHeader()}
        {this.data && this.data.length > 0 ? this.renderBody() : <div class="screen-table-empty">暂无数据</div>}
      </div>
    );
  },
  methods: {
    getValue(item, prop) {
      const arr = prop.split(".");
      arr.every((key) => {
        item = item[key];
        return !!item;
      });
      return item || "";
    },
    getCellClass(col) {
      const arr = ["screen-table-td"];
      if (!col.width) {
        arr.push("table-td-auto");
      }
      if (col.ellipsis) {
        arr.push("ellipsis");
      }
      return arr.join(" ");
    },
    getRowClass(index) {
      const arr = ["screen-table-row"];
      if (index % 2 === 1 || this.background !== false) {
        arr.push("table-row-deep");
      }
      if (this.border) {
        arr.push("table-row-border");
      }
      return arr.join(" ");
    },
    getCellStyle(col) {
      const res = {};
      if (col.width) {
        res.width = typeof col.width === "number" ? `${col.width}px` : col.width;
      }
      return res;
    },
    renderHeader() {
      return (
        <div class="screen-table-row table-row-deep screen-table-header">
          {this.columns?.map((item) => {
            return (
              <div class={this.getCellClass(item)} style={this.getCellStyle(item)}>
                {item.title}
              </div>
            );
          })}
        </div>
      );
    },
    renderRow(item, index) {
      return (
        <div class={this.getRowClass(index)}>
          {this.columns?.map((col) => {
            return (
              <div class={this.getCellClass(col)} style={this.getCellStyle(col)}>
                {this.renderCell(item, col, index)}
              </div>
            );
          })}
        </div>
      );
    },
    renderCell(item, col, index) {
      const value = this.getValue(item, col.prop);
      const cellSlot = this.$scopedSlots[col.prop];
      if (cellSlot) {
        return this.cellSlot({ row: item, value, index });
      }
      if (typeof col.render === "function") {
        return col.render(value, item, index);
      }
      return value;
    },
    handleEventScroll(e) {
      const dom = e.target;
      if (dom.scrollTop + dom.offsetHeight >= dom.scrollHeight - this.scrollOffset) {
        this.$emit("more");
      }
    },
    renderBody() {
      return this.carousel ? (
        <Carousel list={this.data} number={this.rowNumber} class="screen-table-carousel">
          {{
            item: (slotData) => this.renderRow(slotData.item, slotData.index),
          }}
        </Carousel>
      ) : (
        <div class="screen-table-body" onScroll={this.handleEventScroll}>
          {this.data?.map(this.renderRow)}
        </div>
      );
    },
  },
};
</script>

<style lang="less" scoped>
.screen-table {
  display: flex;
  flex-direction: column;
  color: rgba(255, 255, 255, 0.9);
}
.screen-table-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 4px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #463611;
    border-radius: 4px;
    cursor: pointer;
  }
}
.screen-table-row {
  display: flex;
  align-items: center;
  min-height: 38px;
  font-size: 12px;
  text-align: center;
  line-height: 22px;
  &.screen-table-header {
    color: rgba(255, 255, 255, 0.7);
    &.table-row-deep {
      .screen-table-td {
        background-color: rgba(230, 204, 135, 0.5);
        font-size: 16px;
        color: #fff;
      }
    }
  }
  &.table-row-deep {
    .screen-table-td {
      background-color: rgba(249, 230, 179, 0.2);
    }
  }
  &.table-row-border {
    border-bottom: 1px solid rgba(252, 181, 83, 0.05);
  }
}
.screen-table-td {
  padding: 8px 0;
  background-color: rgba(249, 230, 179, 0.3);
  font-size: 14px;
  color: #f9e6b3;
  &.table-td-auto {
    flex: 1;
    min-width: 0;
  }
}
.screen-table-empty {
  padding: 12px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}
</style>
